import { createFileRoute } from "@tanstack/react-router";
import { KBDetailPage } from "@client/components/kb/kb-detail-page";

export const Route = createFileRoute("/_app/kb/$kbId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { kbId } = Route.useParams();
  return <KBDetailPage kbId={kbId} />;
}
